import HoverableView from './HoverableView';

export default HoverableView;
